import cx from "classnames";
import React from "react";
import styles from "./CircleSpinner.scss";

export const CircleSpinner = ({ size, className, light, centered }) => {
  const style = {
    height: size,
    width: size,
    borderWidth: Math.ceil(size * 0.1),
  };
  const spinner = <span className={cx(styles.CircleSpinner, light && styles.light, className)} style={style} />;
  if (centered) {
    return <div className={styles.centered}>{spinner}</div>;
  } else {
    return spinner;
  }
};
